@if (availableItems) {
    <div class="accessibilities" cdkDropListGroup>
        <div class="accessibilities-container">
            @if (!disabled) {
                <div class="drag-container">
                    <div class="drag-container-header">
                        <span>{{ availableItemsTitle }}</span>
                    </div>
                    <div class="drop-list-container">
                        <div
                            id="availableItems"
                            cdkDropList
                            cdkDropListSortingDisabled
                            [cdkDropListData]="availableItems"
                            class="drop-list drop-target"
                            (cdkDropListDropped)="dropIntoAvailableItemsList($event)"
                            [cdkDropListDisabled]="disabled">
                            @for (access of availableItems; track access) {
                                <div class="drop-item available-item" cdkDrag cdkDragPreview>
                                    <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                    <fa-icon [icon]="icon" class="fa-1x type"></fa-icon>
                                    <span class="label">{{ access.item.displayName }}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            @if (!disabled) {
                <div class="drag-buttons-container">
                    <button mat-raised-button class="primary-button move-item" (click)="moveAllItemsInSelectedItemsList()">
                        Tout déplacer
                        <fa-icon
                            [icon]="faAngleDoubleRight"
                            class="fa-1x move-item-icon"
                            matTooltipPosition="right"
                            matTooltipHideDelay="50"
                            matTooltipClass="info-tooltip"></fa-icon>
                    </button>
                    <button mat-raised-button class="primary-button move-item" (click)="moveAllItemsInAvailableItemsList()">
                        <fa-icon
                            [icon]="faAngleDoubleLeft"
                            class="fa-1x move-item-icon"
                            matTooltipPosition="right"
                            matTooltipHideDelay="50"
                            matTooltipClass="info-tooltip"></fa-icon>
                        Tout déplacer
                    </button>
                </div>
            }

            <div class="drag-container">
                <div class="drag-container-header"><span>Peut accéder à</span></div>
                <div class="drop-list-container">
                    <div
                        id="selectedItems"
                        cdkDropList
                        cdkDropListSortingDisabled
                        [cdkDropListData]="selectedItems"
                        class="drop-list drop-target"
                        (cdkDropListDropped)="dropIntoSelectedItemsList($event)"
                        [cdkDropListDisabled]="disabled">
                        @for (access of selectedItems; track access) {
                            <div class="drop-item selected-item" cdkDrag cdkDragPreview [cdkDragDisabled]="access.item.inherited">
                                @if (!disabled) {
                                    @if (access.inherited) {
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle fa-disabled"></fa-icon>
                                    } @else {
                                        <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                                    }
                                }
                                <fa-icon [icon]="icon" class="fa-1x type"></fa-icon>
                                <span class="label">{{ access.item.displayName }}</span>
                                @if (access.inherited) {
                                    <fa-icon [icon]="faSitemap" class="fa-lg hierarchy-icon"></fa-icon>
                                }
                                <fa-icon
                                    [icon]="faCheck"
                                    class="fa-1x default-box-icon"
                                    [ngClass]="{ 'fa-disabled': !access.defaultState }"
                                    (click)="toggleDefaultState(access)"
                                    [matTooltip]="access.defaultState ? 'Ne pas définir comme accès par défaut' : 'Définir comme accès par défaut'"
                                    matTooltipPosition="right"
                                    matTooltipHideDelay="50"
                                    matTooltipClass="info-tooltip"></fa-icon>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
}
